import {FormElementType} from "~/enums/formElementType";
import {Capability} from "../formElementCapability";
import IFormElementSchema from "./iFormElementSchema";
import {generateDropdownItemRestrictions, baseDropdownItemRestrictions} from "./schemaHelper";
import {DefaultOptionType} from "../../defaultOptionType";
import {stateDropdownItems} from "./stateDropdownSchema";
import {VerticalAlignment} from "~/enums/verticalAlignment";

export const baseRestrictions: Capability[] = [
  Capability.defaultable,
  Capability.maskable,
  Capability.repeatable,
  Capability.lengthable,
  Capability.readonlyable,
  Capability.showHideable,
  Capability.formatable,
  Capability.sortable,
  Capability.destroyable,
  Capability.indexable,
  Capability.profileConfig,
];

export const restrictionSchema: object = {
  //Pan Validation base element
  self: [...baseRestrictions, Capability.requireable],
  children: [
    {
      self: [...baseRestrictions, Capability.requireable, Capability.layoutable, Capability.helpTextable],
      children: [
        {
          // Property Account Number
          self: [...baseRestrictions, Capability.requireable],
        },
        {
          //County
          self: [...baseRestrictions, Capability.defaultOption, Capability.requireable],
          children: generateDropdownItemRestrictions(24, baseDropdownItemRestrictions)
        },
      ]
    },
    {
      // Description Text
      self: baseRestrictions,
    },
    {
      //Address Line 1
      self: baseRestrictions,
    },
    {
      //Address line 2
      self: baseRestrictions,
    },
    {
      //Grid Element
      self: [...baseRestrictions, Capability.layoutable, Capability.helpTextable, Capability.requireable],
      children: [
        {
          //City Town Post Office
          self: baseRestrictions
        },
        {
          // State
          self: [...baseRestrictions, Capability.defaultOption],
          children: generateDropdownItemRestrictions(stateDropdownItems.length, baseDropdownItemRestrictions)
        },
        {
          // Zip Code
          self: baseRestrictions
        }
      ]
    }
  ]
};

const countyItems = [
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "01 - Allegany",
      value: 1,
      sort_order: 0,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "02 - Anne Arundel",
      value: 2,
      sort_order: 1,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "03 - Baltimore City",
      value: 3,
      sort_order: 2,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "04 - Baltimore County",
      value: 4,
      sort_order: 3,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "05 - Calvert",
      value: 5,
      sort_order: 4,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "06 - Caroline",
      value: 6,
      sort_order: 5,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "07 - Carroll",
      value: 7,
      sort_order: 6,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "08 - Cecil",
      value: 8,
      sort_order: 7,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "09 - Charles",
      value: 9,
      sort_order: 8,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "10 - Dorchester",
      value: 10,
      sort_order: 9,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "11 - Frederick",
      value: 11,
      sort_order: 10,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "12 - Garrett",
      value: 12,
      sort_order: 11,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "13 - Harford",
      value: 13,
      sort_order: 12,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "14 - Howard",
      value: 14,
      sort_order: 13,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "15 - Kent",
      value: 15,
      sort_order: 14,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "16 - Montgomery",
      value: 16,
      sort_order: 15,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "17 - Prince George's",
      value: 17,
      sort_order: 16,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "18 - Queen Anne's",
      value: 18,
      sort_order: 17,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "19 - St . Mary's",
      value: 19,
      sort_order: 18,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "20 - Somerset",
      value: 20,
      sort_order: 19,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "21 - Talbot",
      value: 21,
      sort_order: 20,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "22 - Washington",
      value: 22,
      sort_order: 21,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "23 - Wicomico",
      value: 23,
      sort_order: 22,
    }
  },
  {
    formElementType: FormElementType.dropdownItem,
    json: {
      label_title: "24 - Worcester",
      value: 24,
      sort_order: 23,
    }
  }
];


export const formElementsSchema: Array<IFormElementSchema> = [
  {
    formElementType: FormElementType.grid,
    json: {
      sort_order: 0,
      layout_config: [1, 1],
    },
    formElements: [
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: "Property Account Number",
          is_required: true,
          help_text: "You can find PAN on your Tax Bill or Assessment Notice",
          sort_order: 0,
          vertical_alignment: VerticalAlignment.Bottom,
        },
      },
      {
        formElementType: FormElementType.dropdown,
        json: {
          label_title: "County",
          is_required: true,
          default_option_locked: true,
          sort_order: 1,
          vertical_alignment: VerticalAlignment.Bottom,
          default_option_type: DefaultOptionType.None,
        },
        formElements: countyItems
      }
    ]
  },
  {
    formElementType: FormElementType.paragraph,
    json: {
      label_title: "<p>If you do not know your Property Account Number, please click the following to access our <a href='https://sdat.dat.maryland.gov/RealProperty/Pages/default.aspx' target='_blank' ref='noopener nofollow'>Real Property Data Search</a></p>",
      is_required: true,
      sort_order: 1
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: "Address Line 1",
      is_required: true,
      is_readonly: true,
      sort_order: 2
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: "Address Line 2",
      is_readonly: true,
      sort_order: 3,
    },
  },
  {
    formElementType: FormElementType.grid,
    json: {
      sort_order: 4,
      layout_config: [1, 1, 1],
    },
    formElements: [
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: "City, Town, or Post Office",
          is_required: true,
          is_readonly: true,
          sort_order: 0
        }
      },
      {
        formElementType: FormElementType.dropdown,
        json: {
          label_title: "State",
          is_required: true,
          is_readonly: true,
          sort_order: 1,
          default_option_locked: true,
          default_option_type: DefaultOptionType.None
        },
        formElements: stateDropdownItems
      },
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: "Zip Code",
          is_required: true,
          is_readonly: true,
          sort_order: 2
        }
      }
    ]
  }
];
